// 处理label值 便于显示
import _ from 'lodash'

/**
 * 是否是具有label值得组件
 */
export function isLabelTag(key) {
  if (
    _.startsWith(key, 'radio') ||
    _.startsWith(key, 'checkbox') ||
    _.startsWith(key, 'select') ||
    _.startsWith(key, 'image_select') ||
    _.startsWith(key, 'cascader')
  ) {
    return true
  }
  return false
}

export function handleChangeLabel(models, item, value) {
  const key = item.vModel
  if (isLabelTag(key)) {
    models[`${key}label`] = getCheckedLabel(value, item.config.options, item, models)
  } else if (_.startsWith(key, 'nps')) {
    // 计算NPS标签
    models[`${key}label`] = getNPSLabel(value, item.npsTagList)
  }
}

// 获取选中的值
export function getCheckedLabel(val, options, item, formModel) {
  if (options) {
    // 结果是数据 checkbox 级联等
    if (Array.isArray(val)) {
      const labelArr = []
      val.forEach((v) => {
        // 特殊处理checkBox 其他输入框输入的情况
        const obj = getObject(options, 'value', v)
        if (item.typeId === 'CHECKBOX') {
          labelArr.push(`${obj?.label || ''}${obj?.inputValue ? ' _ ' + obj.inputValue : ''}`)
        } else {
          labelArr.push(obj ? obj.label : '')
        }
      })
      return labelArr
    }
    if (item.typeId === 'RADIO' && val !== null) {
      // 其他选项的值最终保存为： 选项名+选项值
      let curObj = getObject(options, 'value', val)
      return `${curObj ? curObj.label : ''}${curObj?.inputValue ? ' _ ' + curObj.inputValue : ''}`
    }
    const obj = getObject(options, 'value', val)
    return obj ? obj.label : ''
  }
  return ''
}

/**
 * 从数组递归查找符合条件的数据
 * @param array
 * @param key
 * @param value
 * @returns {*}
 */
function getObject(array, key, value) {
  let o
  array.some(function iter(a) {
    if (a[key] === value) {
      o = a
      return true
    }
    return Array.isArray(a.children) && a.children.some(iter)
  })
  return o
}

/**
 * 获取NPS选中值所属标签
 * @param {number} val - 当前选中值
 * @param {Array} npsTagList - NPS标签列表，每个元素包含 name、beginScore、endScore
 * @param {boolean} allowMultiple - 是否允许重复匹配（默认 false，只匹配第一个）
 * @returns {Array|string} - 返回匹配到的分组名称或数组（如果允许多个）
 */
export function getNPSLabel(val, npsTagList, allowMultiple = false) {
  if (val === null || val === '') return ''
  const matched = npsTagList.filter((tag) => val >= tag.beginScore && val <= tag.endScore)
  if (allowMultiple) {
    return matched.map((g) => g.name)
  }
  return matched.length ? matched[0].name : '' // 默认只取第一个
}
